import { AxiosError } from 'axios';
import { getApiClient } from './api.base';
import { getStoredToken } from '../session/account-store.service';
import { FundraisingCreatePayload } from '@/models/fundraising-create-payload.model';
import { FundraisingCreateResponse } from '@/models/fundraising-create-response.model';
import { clearLoading, setLoading } from '@/services/utils/loading.service';

type Response = FundraisingCreateResponse & AxiosError;

export const fundraisingCreateService = async (
  payload: FundraisingCreatePayload,
): Promise<Response> => {
  // console.log(payload.amount_target);
  // console.log(typeof payload.amount_target);
  setLoading();
  try {
    const token = getStoredToken();
    const response = await getApiClient('auth', token ?? '').post(
      '/api/v1/account/project',
      payload,
    );
    // const apiClient = getApiClient('auth', token ?? '');
    // const response = await apiClient.post(
    //   'http://localhost:5000/account/project',
    //   payload
    // );
    clearLoading();
    return response.data as Response;
  } catch (errorResponse) {
    const error = errorResponse as Response;
    console.info(error);
    clearLoading();
    return error;
  }
};
